"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockSession = void 0;
const faker_1 = require("@faker-js/faker");
const __1 = require("../..");
function createMockSession(overwrites) {
    return Object.assign({ id: faker_1.faker.datatype.number(), uuid: faker_1.faker.datatype.uuid(), organizationType: faker_1.faker.helpers.arrayElement(Object.values(__1.CompanyType)), email: faker_1.faker.internet.email(), firstName: faker_1.faker.name.firstName(), lastName: faker_1.faker.name.lastName(), subdomain: faker_1.faker.internet.domainName(), authProviders: ['google'], company: {
            id: faker_1.faker.datatype.number(),
            name: faker_1.faker.company.name(),
        }, preferredHost: faker_1.faker.internet.domainName(), roles: [__1.CompanyType.Admin], isAdmin: true }, overwrites);
}
exports.createMockSession = createMockSession;
//# sourceMappingURL=User.factory.js.map